import Base from "components/Creation/components/Base";
import { useEffect, useRef, useState } from "react";
import Bubble from "../What/components/BubblesGrid/components/Bubble";
import BubbleChoices from "./components/BubbleChoices";
import BubbleSelect from "./components/BubbleSelect";
import { useCorporateMode } from "context/CorporateModeContext";
import useSelection from "hooks/useSelection";
import Warning from "../Warning";
import { useHistory } from "react-router-dom";
import MirumModal from "components/MirumModal";
import { Animated } from "react-animated-css";
import { AiOutlineInfoCircle } from "react-icons/ai";

const Anything = () => {
  const history = useHistory();
  const { isCorporate } = useCorporateMode();
  const peopleInputRef = useRef(null);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [selected, setSelected] = useState({
    noOfPeople: 2,
    vibe: [],
    accessibility: [],
    fromLondon: [],
    earlyReveal: [],
    notes: "",
  });
  const { setSelectionForKey, redirectIfNotValidUpUntilKey, keyIsValidated } =
    useSelection({
      key: "anything",
      setter: setSelected,
    });

  useEffect(() => {
    redirectIfNotValidUpUntilKey("anything");
  }, []);

  const bubbleClassName = "rounded-sm md:rounded-full";

  const n = Number(selected.noOfPeople);
  const corporatePeopleValid =
    selected.noOfPeople !== undefined &&
    selected.noOfPeople !== null &&
    Number.isInteger(n) &&
    n >= 2;

  return (
    <Base
      title="Anything Else?"
      footerOnClickedNext={() => {
        if (!keyIsValidated("anything")) {
          setShowErrorMsg(true);
        } else {
          history.push("/budget");
        }
      }}
    >
      <MirumModal
        show={showErrorMsg}
        onPositiveBtnClick={() => {
          setShowErrorMsg(false);
        }}
        onDidDismiss={() => {
          setShowErrorMsg(false);
        }}
        hideNegativeBtn={true}
      >
        <div>
          <h1>tell us more</h1>
          <p className="my-4">
            please ensure you've answered all questions and added any applicable
            notes
          </p>
        </div>
      </MirumModal>
      <div className="container mx-auto grow items-center flex flex-col justify-center z-10 py-8">
        {/* <h1 className="font-bold mb-4">Number of People</h1> */}
        <div className="grid grid-cols-1 md:grid-cols-2 w-full md:w-11/12 mx-auto text-center items-end gap-8">
          <div className="px-4 flex flex-col items-center justify-center">
            <h2 className="mb-4">Number of People</h2>
            {isCorporate ? (
              <div className="w-1/2 md:w-1/3">
                <div className="w-full pb-[100%] relative">
                  <div className="w-full h-full absolute top-0 left-0">
                    <Bubble
                      cellNo={0}
                      shouldAnimate={true}
                      isSelected={false}
                      showAsPink={corporatePeopleValid}
                      onClick={() => peopleInputRef.current?.focus()}
                      className={`${bubbleClassName} !rounded-full`}
                    >
                      <div className="flex flex-col items-center justify-center h-full w-full px-3 pt-2 pb-1">
                        <input
                          ref={peopleInputRef}
                          id="noOfPeopleCorporate"
                          type="number"
                          min={2}
                          step={1}
                          inputMode="numeric"
                          value={
                            selected.noOfPeople === null ||
                            selected.noOfPeople === undefined
                              ? ""
                              : String(selected.noOfPeople)
                          }
                          onChange={(e) => {
                            const raw = e.target.value;
                            if (raw === "") {
                              setSelectionForKey({
                                ...selected,
                                noOfPeople: undefined,
                              });
                              return;
                            }
                            const parsed = parseInt(raw, 10);
                            if (!Number.isNaN(parsed)) {
                              setSelectionForKey({
                                ...selected,
                                noOfPeople: parsed,
                              });
                            }
                          }}
                          onClick={(e) => e.stopPropagation()}
                          placeholder="—"
                          className={`mirum-headcount-bubble-input w-[90%] max-w-none bg-transparent rounded-none shadow-none text-center text-4xl md:text-[3vw] font-bold lowercase px-1 pt-1 pb-0.5 mb-0.5 border-t-0 border-l-0 border-r-0 border-b-2 border-solid focus:ring-0 focus:outline-none focus-visible:outline-none placeholder:opacity-40 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none ${
                            corporatePeopleValid
                              ? "border-b-white/60 text-white placeholder-white/50"
                              : "border-b-[var(--orange)]/55 text-gray-900 placeholder-gray-400"
                          }`}
                          style={
                            corporatePeopleValid
                              ? { textShadow: "0px 0px 9px #ce5151" }
                              : undefined
                          }
                        />
                        <span
                          className={`text-xs md:text-sm lowercase ${
                            corporatePeopleValid
                              ? "text-white/90"
                              : "text-gray-700"
                          }`}
                          style={
                            corporatePeopleValid
                              ? { textShadow: "0px 0px 6px #ce5151" }
                              : undefined
                          }
                        >
                          people (min. 2)
                        </span>
                      </div>
                    </Bubble>
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-1/2 md:w-1/3">
                <BubbleSelect
                  value={selected.noOfPeople}
                  onChange={(value) => {
                    setSelectionForKey({
                      ...selected,
                      noOfPeople: value,
                    });
                  }}
                  title=""
                  bubbleClassName={bubbleClassName}
                />
              </div>
            )}
          </div>
          <div className="px-4">
            <div className="block">
              <BubbleChoices
                availableItems={["casual", "smart-casual", "dressy"]}
                selectedItems={selected.vibe}
                onSelectedItems={(items) =>
                  setSelectionForKey({ ...selected, vibe: items })
                }
                title="Vibe"
                className="grid-cols-2 md:grid-cols-3"
              />
            </div>
          </div>
          <div className="px-4">
            <div className="block">
              <BubbleChoices
                mode="single"
                availableItems={["yes", "no"]}
                selectedItems={selected.accessibility}
                onSelectedItems={(items) =>
                  setSelectionForKey({ ...selected, accessibility: items })
                }
                className="grid-cols-2"
                title="Accessibility"
              />
            </div>
          </div>
          <div className="px-4">
            <div className="block">
              <BubbleChoices
                mode="single"
                availableItems={["yes", "no"]}
                selectedItems={selected.fromLondon}
                onSelectedItems={(items) =>
                  setSelectionForKey({ ...selected, fromLondon: items })
                }
                className="grid-cols-2"
                title="Are you from London?"
              />
            </div>
          </div>
          <div className="px-4">
            <div className="block">
              <div className="mb-8 flex items-center justify-center gap-1">
                <h2>Early reveal?</h2>
                <div className="mirum-info-box-holder relative">
                  <div
                    style={{
                      color: "var(--orange)",
                      fontSize: "24px",
                      position: "relative",
                      top: "3px",
                    }}
                    className="p-2 cursor-pointer"
                  >
                    <AiOutlineInfoCircle />
                  </div>
                  <div className="lowercase mirum-info-box-content fixed md:absolute top-[100px] md:top-0 left-0 py-4 px-6 bg-white rounded-lg shadow-lg z-50 w-full w-[95%] left-[2.5%] mx-auto md:w-[300px] transition-all">
                    if you'd like to find out 24 hours before rather than 1 hour
                    before
                  </div>
                </div>
              </div>
              <BubbleChoices
                mode="single"
                availableItems={["yes", "no"]}
                selectedItems={selected.earlyReveal || []}
                onSelectedItems={(items) =>
                  setSelectionForKey({ ...selected, earlyReveal: items })
                }
                className="grid-cols-2"
                title=""
              />
            </div>
          </div>
        </div>
        {selected.noOfPeople &&
          selected.vibe.length > 0 &&
          selected.accessibility.length > 0 &&
          selected.fromLondon.length > 0 && (
            <div className="w-full text-center mt-8">
              {/* {selected.accessibility.indexOf("yes") > -1 && (
                <Animated animationIn="fadeInUp">
                  <div className="hidden md:block shadow-xl bg-white py-4 px-8 inline-block mx-auto rounded-xl border-sm border-[#F9F9F9] text-black">
                    <p className="text-black lowercase">
                      Accessibility Required: Please provide additional details
                      below.
                    </p>
                  </div>
                </Animated>
              )} */}
              <h3 className="mt-4 lowercase" style={{ color: "#7994FF" }}>
                Please provide additional details below
              </h3>
              <p className="m-4">
                (exclusions / special occasions / accessibility requirements
                etc.)
              </p>
              <textarea
                className={`mirum-text-field w-full md:w-6/12 mx-auto rounded-lg ${
                  selected.accessibility.indexOf("yes") > -1 &&
                  (!selected.notes || selected.notes?.length <= 2)
                    ? "border-[var(--blue)]"
                    : ""
                }`}
                value={selected.notes}
                onChange={(e) => {
                  setSelectionForKey({
                    ...selected,
                    notes: e.target.value,
                  });
                }}
                placeholder="e.g. no confined spaces. it’s for a birthday meal. nothing to do with heights"
              />
            </div>
          )}
        {!keyIsValidated("anything") && (
          <div className="mt-8">
            <Warning msg="please ensure you've answered all questions and added any applicable notes" />
          </div>
        )}
      </div>
    </Base>
  );
};

export default Anything;
